import clsx from 'clsx';
import { memo } from 'react';
import { Tooltip } from '@optiaxiom/react';

import { NodeBadge as NodeBadgeType } from '../../../../hooks/useNodeRenderer';

import { BadgePosition, badgePositions, badgeVariants, nodeBadge } from './NodeBadges.css';

type NodeBadgeProps = {
  badge: NodeBadgeType;
  position: BadgePosition;
};

export const NodeBadge = memo(({ badge, position }: NodeBadgeProps) => {
  const badgeContent = (
    <div
      className={clsx(
        nodeBadge,
        badgePositions[position],
        badge.variant && badgeVariants[badge.variant],
        badge.className
      )}
    >
      {badge.content}
    </div>
  );

  if (badge.tooltip) {
    return <Tooltip content={badge.tooltip}>{badgeContent}</Tooltip>;
  }

  return badgeContent;
});

NodeBadge.displayName = 'NodeBadge';
